import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import classNames from 'lib/util/classNames'
import { useItemContext } from '../Item/context/ItemContext'
import styles from './Content.module.scss'
import useCollapsible from './hooks/useCollapsible'

/**
 * The Accordion `Content`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Content (props) {
  const { children, className } = props
  const { ariaId, duration, isExpanded } = useItemContext()
  const ref = useRef()
  const isVisible = useCollapsible(ref, isExpanded, duration)
  const attributes = useMemo(
    () => ({
      id: `${ariaId}-region`,
      className: classNames([
        className,
        styles.content,
        isVisible && styles.render
      ]),
      'aria-expanded': isExpanded,
      'aria-labelledby': `${ariaId}-toggle`,
      role: 'region'
    }),
    [className, isExpanded]
  )

  return (
    <div {...attributes}>
      <div ref={ref} className={styles.contentCollapsible}>
        <div className={styles.contentDisplay}>{children}</div>
      </div>
    </div>
  )
}

/** @type {object} */
Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

Content.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Content)
